exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dz-container{display:-webkit-box;display:-ms-flexbox;display:flex}.dz-spec-text{margin-top:4px;font-size:.65rem;color:#6c757d}.pro-tip-container{font-size:11px}.pro-tip-container h6{font-size:12px}.pro-tip-container ul{padding-left:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f984f252","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/franchise_component/inventory/item/vuetableitem_form.vue
// module id = 4gPu
// module chunks = 99